import { ActionTree } from 'vuex'
import { RootState } from '@/store'
import { UiState } from '@/store/ui'


export const actions: ActionTree<UiState, RootState> = {
    async minimizeNav({ commit }): Promise<void> {
        commit('minimizeNav')
    },
    async maximizeNav({ commit }): Promise<void> {
        commit('maximizeNav')
    },
    async toggleNav({ commit }): Promise<void> {
        commit('toggleNav')
    },
    async toggleCollapsableActive({ commit }, payload: { active: boolean }): Promise<void> {
        commit('toggleCollapsableActive', payload)
    },
}
